import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { HelloComponent } from './hello/hello.component'
import { WorkComponent } from './work/work.component'
import { IpscComponent } from './ipsc/ipsc.component'
import { RunningComponent } from './running/running.component'

const routes: Routes = [
  { path: '', component: HelloComponent},
  { path: 'ipsc', component: IpscComponent },
  { path: 'latest-work', component: WorkComponent},
  { path: 'latest-work/:name', component: WorkComponent},
  { path: 'running', component: RunningComponent }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts